import { render, staticRenderFns } from "./CommonHairdressingInfo.vue?vue&type=template&id=124e8b7a&scoped=true&"
import script from "./CommonHairdressingInfo.vue?vue&type=script&lang=js&"
export * from "./CommonHairdressingInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommonHairdressingInfo.vue?vue&type=style&index=0&id=124e8b7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e8b7a",
  null
  
)

export default component.exports